import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { FC } from 'react';
import { useDarkMode, useMediaUp } from '../../../hooks';
import { ArchitectureIcon } from '../../../svgs/gpm';

interface WhyUsProps {
  title: string;
  description: string;
  list: Array<{ title: string; text: string }>;
}

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: theme.spacing(10, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(15, 0),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(13.5, 0),
    },
  },
  item: {
    position: 'relative',
  },
  gpmTitle: {
    color: '#116666',
    fontSize: 35,
    lineHeight: '35px',
    fontWeight: 700,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      fontSize: 50,
      lineHeight: '45px',
    },
  },
  description: {
    color: (isDarkMode) => (isDarkMode ? theme.palette.common.white : '#0A1524'),
    fontSize: 15,
    fontWeight: 400,
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: 234,
    },
  },
  link: {
    boxShadow: 'none',
    borderRadius: '0 10px',
    padding: '14px 35px',
    textTransform: 'none',
    fontSize: 15,
    lineHeight: 1,
    fontWeight: 500,
    color: '#0061E5',
    border: '2px solid #0061E5',
    backgroundColor: 'transparent',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#0061E5',
      color: '#ffffff',
    },
  },
  card: {
    border: '1px solid #111133',
    borderRadius: '0 24px 0 24px',
    maxWidth: 297,
    marginRight: theme.spacing(5),
    marginBottom: theme.spacing(3),
    minHeight: 144,
    padding: theme.spacing(0, 4),
  },
  cardTitle: {
    fontSize: 64,
    fontWeight: 700,
    color: '#116666',
  },
  text: {
    color: (isDarkMode) => (isDarkMode ? theme.palette.common.white : '#0A1524'),
    fontSize: 15,
  },
}));

const WhyUs: FC<WhyUsProps> = (props) => {
  const { title, description, list } = props;
  const { isDarkMode } = useDarkMode();
  const classes = useStyles(isDarkMode);
  const mediaUp = useMediaUp('md');

  return (
    <Container maxWidth={false} fixed>
      <Grid className={classes.content} justifyContent="space-between" alignItems={'center'} container spacing={mediaUp ? 8 : 4}>
        <Grid className={classes.item} md={4} xs={12} item>
          {mediaUp && (
            <Box position={'absolute'} right={-10} top={'80%'}>
              <ArchitectureIcon />
            </Box>
          )}
          <Typography className={classes.gpmTitle}>{title}</Typography>

          <Typography className={classes.description}>{description}</Typography>
          <Box mt={8} mb={5}>
            <a className={classes.link} href={'https://gpmgis.com/'} target="_blank" rel="noopener noreferrer">
              {'Visit website'}
            </a>
          </Box>
        </Grid>
        <Grid md={8} xs={12} item>
          <Grid justifyContent={mediaUp ? 'flex-end' : 'flex-start'} container>
            {list.map((item, index) => (
              <Grid className={classes.card} item md={6} xs={12} key={index}>
                <Typography className={classes.cardTitle}>{item.title}</Typography>
                <Typography className={classes.text}>{item.text}</Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default WhyUs;
